import {
	Text,
	View,
	StyleSheet,
	Pressable,
	FlatList,
	Image,
} from "react-native";
import { TouchableOpacity } from "react-native-gesture-handler";
import { discounts_4schools_image_path } from "../../../store/api";
const pizzaLogo = require("../../../../assets/images/pizzaHut_logo.png");
const mcDonaldLogo = require("../../../../assets/images/mcDonald_logo.png");
const paoLogo = require("../../../../assets/images/pao_logo.png");
const oggiLogo = require("../../../../assets/images/oggi_logo.png");

const AllDiscounts = ({ allDiscounts, navigation, setSelectedFilters }) => {
	return (
		<View style={styles.container}>
			<View style={styles.header}>
				<Text style={styles.headerTitle}>Todos</Text>
				<Pressable
					onPress={() =>
						setSelectedFilters(currentValue => ({
							...currentValue,
							showRails: false,
						}))
					}
				>
					<Text style={styles.headerReadMore}>Ver mais</Text>
				</Pressable>
			</View>
			<View style={styles.discountsContainer}>
				{allDiscounts.map(item => {
					return (
						<Pressable
							style={styles.item}
							onPress={() => {
								navigation.navigate("SpecificDiscount", {
									info: item,
									navigation: navigation,
								});
							}}
						>
							<Image
								style={styles.image}
								source={{
									uri: discounts_4schools_image_path + item.logo_image_id,
								}}
							/>
							<Text
								style={{
									color: item.title_color,
									fontSize: 12,
									lineHeight: 16,
									marginTop: 20,
									fontFamily: "DmSans-bold",
								}}
							>
								{item.company_name}
							</Text>
							<Text style={styles.description}>{item.title}</Text>
						</Pressable>
					);
				})}
			</View>
		</View>
	);
};

export default AllDiscounts;

const styles = StyleSheet.create({
	container: {
		marginBottom: 20,
	},
	header: {
		flexDirection: "row",
		marginBottom: 12,
		paddingHorizontal: 24,
		justifyContent: "space-between",
	},
	headerTitle: {
		fontSize: 18,
		lineHeight: 26,
		color: "#3C351F",
		fontFamily: "DmSans-bold",
	},
	headerReadMore: {
		fontFamily: "DmSans-bold",
		fontSize: 14,
		color: "#0843F5",
		marginTop: 3,
	},
	item: {
		width: "45%",
		maxWidth: 200,
		height: 192,
		overflow: "hidden",
		borderRadius: 20,
		backgroundColor: "#fff",
		paddingTop: 20,
		paddingHorizontal: 15,
		marginBottom: 15,
		marginRight: 8,
	},
	image: { height: 60, resizeMode: "contain" },
	discountsContainer: {
		flexWrap: "wrap",
		flexDirection: "row",
		width: "100%",
		marginBottom: 70,
		justifyContent: "space-evenly",
	},
	description: {
		color: "#000",
		marginTop: 12,
		fontWeight: "400",
		fontSize: 16,
		lineHeight: 16,
		fontFamily: "DmSans",
	},
});
